import { render, staticRenderFns } from "./ArticleTableOfContents.vue?vue&type=template&id=5a5a5469"
import script from "./ArticleTableOfContents.vue?vue&type=script&lang=js"
export * from "./ArticleTableOfContents.vue?vue&type=script&lang=js"
import style0 from "./ArticleTableOfContents.vue?vue&type=style&index=0&id=5a5a5469&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports